export const API_URL = process.env.VUE_APP_API_URL;
export const DEFAULT_OBJECT = { data: { attributes: {} }, included: [] };
